import { memo } from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  message: string;
  variant?: 'general' | 'field';
  className?: string;
}

export const ErrorDisplay = memo<ErrorDisplayProps>(({ 
  message, 
  variant = 'general',
  className = '' 
}) => {
  if (variant === 'field') {
    return (
      <div className={`flex items-center gap-1 text-xs text-red-600 ${className}`}>
        <AlertCircle className="h-3 w-3" />
        <span>{message}</span>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2 ${className}`}>
      <AlertCircle className="h-4 w-4 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
});

ErrorDisplay.displayName = 'ErrorDisplay'; 
